// extracted by mini-css-extract-plugin
export default {"container":"Accordion_container__JapFA","expanded":"Accordion_expanded__ORChb","line":"Accordion_line__GOOVr"};